import { Box, IconButton, Typography } from "@mui/material"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import React from "react"
import { truncateString } from "@utils"
import { dsColorNew } from "@palette"

export default function PopoverTitle({ carDescription, onClose }) {

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 1.75, py: 1.5, borderBottom: `1px solid ${dsColorNew.grayBorder}`, cursor: 'default' }}>
		<Box sx={{
			width: 30, height: 30, borderRadius: '8px', flexShrink: 0,
			display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue,
		}}>
			<IconSeeker icon="car" sx={{ fontSize: 13 }}/>
		</Box>
		<TooltipSeeker title={carDescription?.length > 20 && carDescription}>
			<Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle, minWidth: 0 }}>
				{!!carDescription && truncateString(carDescription, 20)}
			</Typography>
		</TooltipSeeker>
		<IconButton
			data-tour-id="tour-popover-close"
			aria-label="Close"
			onClick={e => { e.stopPropagation(); onClose() }}
			sx={{ ml: 'auto', width: 28, height: 28, borderRadius: '8px', color: dsColorNew.textSubtle }}
		>
			<IconSeeker icon="xmark" sx={{ fontSize: 13 }}/>
		</IconButton>
	</Box>
}
